function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#Success_svg__clip0)",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, React.createElement("path", {
  d: "M36.93 12.48a1.5 1.5 0 01.247 2.106L21.498 34.423a3.645 3.645 0 01-.847.795l-.006.004a3.599 3.599 0 01-4.98-.97l-4.891-6.942a1.5 1.5 0 012.452-1.728l4.9 6.954.02.03a.599.599 0 00.974.028l.017-.022 15.686-19.846a1.5 1.5 0 012.107-.247z"
}), React.createElement("path", {
  d: "M24 2.998c-11.598 0-21 9.402-21 21s9.402 21 21 21 21-9.402 21-21-9.402-21-21-21zm-24 21c0-13.254 10.746-24 24-24s24 10.746 24 24-10.746 24-24 24-24-10.746-24-24z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "Success_svg__clip0"
}, React.createElement("path", {
  d: "M0 0h48v48H0V0z"
})));

function SvgSuccess(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, props), _ref, _ref2);
}

export default SvgSuccess;